import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelElement } from '@app/model-composer';

@Component({
  selector: 'app-element-card',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="
        ipe:w-full ipe:min-w-0
        ipe:group ipe:text-left ipe:cursor-pointer
        ipe:flex ipe:flex-col ipe:gap-3
        ipe:transition
        ipe:disabled:opacity-40 ipe:disabled:cursor-not-allowed
        ipe:bg-white
      "
      [disabled]="disabled()"
      (click)="onClick()"
    >
      <div class="
        ipe:h-40
        ipe:bg-[#f9f8f6]
        ipe:flex ipe:items-center ipe:justify-center
        ipe:overflow-hidden
      ">
        <img
          [src]="element().image"
          alt=""
          class="
            ipe:mix-blend-multiply
            ipe:h-full
            ipe:object-contain
            ipe:transition-transform
            ipe:duration-300
            ipe:ease-out
            ipe:group-hover:scale-110
            ipe:transform-gpu
          "
        />
      </div>

      <div class="ipe:px-6.5 ipe:md:pl-2 ipe:py-1">
        <div class="ipe:font-medium ipe:truncate">{{ element().name }}</div>
        <div class="ipe:text-sm ipe:text-gray-500 ipe:truncate">{{ element().dimensions }}</div>
        <div class="ipe:text-sm ipe:text-gray-500 ipe:truncate">{{ element().typeLabel }}</div>
      </div>
    </button>
  `,
  styles: [`
    :host { display: block; min-width: 0; }
  `],
})
export class ElementCardComponent {
  readonly element = input.required<ModelElement>();
  readonly disabled = input<boolean>(false);
  readonly select = output<ModelElement>();
  protected onClick(): void {
    if (this.disabled()) return;
    this.select.emit(this.element());
  }
}
